<template>
  <div class="quotes-container">
    <img :src="tool.imgURL" alt="image" class="quote-image" />
  </div>
</template>
<script>
export default {
  name: "quotable",
  data() {
    return {
      quote: 1
    };
  },
  mounted() {
    setInterval(() => {
      if (this.quote < 4) {
        this.quote++;
      } else {
        this.quote = 1;
      }
    }, 5000);
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    idprop: {
      type: String
    },
    showTracking: {
      type: Boolean
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.quotes-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .quote-image {
    margin-top: 12px;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}
</style>
